<template>
  <Panel
    :id="id"
    :title="title"
    :toggleable="toggleable"
    :collapsed="collapsed"
    :pt="{
      root: { class: wrapperClass }
    }"
    :class="{ 'p-disabled': disabled }"
    @toggle="onToggle"
  >
    <template #header v-if="$slots.header">
      <slot name="header"></slot>
    </template>
    <template #icons v-if="$slots.icons">
      <slot name="icons"></slot>
    </template>
    <slot></slot>
  </Panel>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import Panel from 'primevue/panel'
import type { PanelToggleEvent } from 'primevue/panel'

interface Props {
  title?: string
  toggleable?: boolean
  collapsed?: boolean
  wrapperClass?: string
  disabled?: boolean
  expandAriaLabel?: string
}

const props = withDefaults(defineProps<Props>(), {
  title: undefined,
  toggleable: false,
  collapsed: false,
  wrapperClass: undefined,
  disabled: false,
  expandAriaLabel: 'Toggle Panel'
})

const emit = defineEmits<{
  (e: 'toggle', event: PanelToggleEvent): void
  (e: 'update:collapsed', value: boolean): void
}>()

const id = ref(`mop_panel_${Math.floor(Math.random() * 1000)}`)

const onToggle = (event: PanelToggleEvent) => {
  if (!props.disabled) {
    emit('update:collapsed', !props.collapsed)
    emit('toggle', event)
  }
}
</script>


